import type { GetEligibleCampaignsResponseType } from "@jti/rest-api-types";

export const filterEligibleLoyaltyVouchers = (
  vouchers: GetEligibleCampaignsResponseType[]
): GetEligibleCampaignsResponseType[] => vouchers.filter((voucher) => voucher.is_eligible);

export const getMinimumLoyaltyVoucherCost = (vouchers: GetEligibleCampaignsResponseType[]): number =>
  vouchers.find((voucher) => voucher.is_eligible)?.points ?? 0;

export const getMaximumLoyaltyVoucherValue = (vouchers: GetEligibleCampaignsResponseType[]): number => {
  const eligible = filterEligibleLoyaltyVouchers(vouchers);
  if (!eligible.length) {
    return 0;
  }

  return eligible[eligible.length - 1]?.price ?? 0;
};
